/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const StocktakeReviewService = {
  dataSourceConfig(params) {
    let url = "api/StockCommitted";
    return ApiService.createDataSource(url, params);
  },
  async getStocktakeReviewBatches(code, itemCode) {
    const requestScreenData = {
      url: "api/StockBatchCommitted",
      filter: `StocktakeCode eq ${code} and ProductCode eq '${itemCode}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
};

export { StocktakeReviewService };
